<template>
  <el-dialog
    :title="DIALOG_TITLE_TYPE[dialogType]"
    :visible="isVisible"
    :close-on-click-modal="false"
    width="80%"
    @close="handleClose"
  >
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-position="left"
      label-width="100px"
      style="width: 90%; margin-left:20px;"
    >
      <el-form-item label="活动ID" prop="activityId">
        <el-select
          v-model="form.activityId"
          filterable
          :loading="activitySearchLoading"
          placeholder="请选择活动"
          style="width: 100%"
        >
          <el-option
            v-for="item in activityList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="活动状态" prop="status">
        <el-select v-model="form.status" placeholder="请选择状态" style="width: 100%">
          <el-option
            v-for="item in ACTIVITY_STATUS"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="规格配置" prop="specsJson">
        <el-button type="primary" @click="showSelectProductModal = true">选择商品规格</el-button>
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input-number v-model="form.sort" :min="0"></el-input-number>
      </el-form-item>
    </el-form>

    <div style="margin: 20px;">
      <div style="margin-top: 20px;">
        <el-table :data="selectedSpecs" border size="small" style="width: 100%">
          <el-table-column
            label="规格名称"
            align="center"
            prop="specsName"
            width="120"
          ></el-table-column>

          <!-- <el-table-column
            label="库存"
            width="50"
            align="center"
            prop="stock"
          ></el-table-column> -->
          <el-table-column label="原价" width="50" align="center" prop="price"></el-table-column>
          <el-table-column label="秒杀价" align="center">
            <template slot-scope="scope">
              <div :class="{ 'has-error': isPriceError(scope.row) }">
                <el-input-number
                  v-model="scope.row.seckillPrice"
                  :min="0"
                  size="mini"
                ></el-input-number>
                <div v-if="isPriceError(scope.row)" class="error-tip">必须>0且不为空</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="秒杀库存" align="center">
            <template slot-scope="scope">
              <div :class="{ 'has-error': isStockError(scope.row) }">
                <el-input-number
                  v-model="scope.row.seckillStock"
                  :min="0"
                  size="mini"
                ></el-input-number>
                <div v-if="isStockError(scope.row)" class="error-tip">必须>0且不为空</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="单次限购" align="center">
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.singleLimit"
                :min="0"
                size="mini"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="总限购" align="center">
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.totalLimit"
                :min="0"
                size="mini"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            class-name="status-col"
            prop="status"
            width="100"
            label="状态"
            align="center"
          >
            <template slot-scope="scope">
              <el-select v-model="scope.row.status" size="mini" style="width: 80px">
                <el-option :label="'启用'" :value="1" />
                <el-option :label="'停用'" :value="2" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="80">
            <template slot-scope="scope">
              <el-button type="danger" size="mini" @click="removeSpec(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleConfirm" :loading="btnLoading">确定</el-button>
    </div>

    <!-- 选择商品弹窗 -->
    <SelectProductModal
      :visible.sync="showSelectProductModal"
      :selected-specs="selectedSpecs"
      @confirm="handleSelectProduct"
    />
  </el-dialog>
</template>

<script>
import { ACTIVITY_STATUS, DIALOG_TITLE_TYPE } from "@/utils/enumUtile";
import { BRAND_STATUS_CSS } from "@/utils/enumUtileCss";
import SelectProductModal from "./SelectProductModal.vue";
import { getActivityList } from "@/api/seckill";

export default {
  name: "ActivityGoodsForm",
  components: { SelectProductModal },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    dialogType: {
      type: String,
      default: "CREATE"
    },
    editData: {
      type: Object,
      default: () => ({})
    },
    btnLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ACTIVITY_STATUS() {
      return ACTIVITY_STATUS;
    },
    BRAND_STATUS_CSS() {
      return BRAND_STATUS_CSS;
    },
    DIALOG_TITLE_TYPE() {
      return DIALOG_TITLE_TYPE;
    }
  },
  data() {
    return {
      isVisible: false,
      isSubmitted: false,
      form: {
        id: null,
        activityId: null,
        goodsId: null,
        specsJson: null,
        sort: null,
        status: 1
      },
      showSelectProductModal: false,
      selectedProduct: null,
      selectedSpecs: [],
      activityList: [],
      activitySearchLoading: false,
      rules: {
        activityId: [{ required: true, message: "活动ID不能为空", trigger: "blur" }]
      }
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.isVisible = val;
        if (val) {
          this.initForm();
        }
      }
    }
    // editData: {
    //   handler(val) {
    //     if (this.isVisible) {
    //       this.initForm();
    //     }
    //   },
    //   deep: true
    // }
  },
  methods: {
    initForm() {
      this.isSubmitted = false;
      if (this.activityList.length === 0) {
        this.loadActivityList();
      }
      if (this.dialogType === "UPDATE" && this.editData && Object.keys(this.editData).length > 0) {
        console.log("编辑", this.editData);
        this.form = {
          id: this.editData.id,
          activityId: this.editData.activityId || null,
          goodsId: this.editData.goodsId || null,
          sort: this.editData.sort || null,
          status: this.editData.status
        };
        if (this.editData.goodsId) {
          this.selectedProduct = { id: this.editData.goodsId };
          this.selectedSpecs = this.editData.specs.map(item => ({
            specsId: item.specsId,
            specsName: item.specsName,
            seckillPrice: item.seckillPrice,
            price: item.originalPrice,
            stock: item.stock,
            seckillStock: item.seckillStock,
            singleLimit: item.singleLimit,
            totalLimit: item.totalLimit,
            status: item.status,
            goodsId: this.editData.goodsId
          }));
        }
      } else {
        this.form = {
          id: null,
          activityId: null,
          goodsId: null,
          specsJson: null,
          sort: null,
          status: 1
        };
        this.selectedProduct = null;
        this.selectedSpecs = [];
        if (this.$refs.form) {
          this.$refs.form.resetFields();
        }
      }
    },
    loadActivityList() {
      this.activitySearchLoading = true;
      getActivityList({ page: 1, pageSize: 100 })
        .then(response => {
          this.activityList = response.data.entitys.map(item => ({
            value: item.id,
            label: item.name
          }));
        })
        .finally(() => {
          this.activitySearchLoading = false;
        });
    },

    handleSelectProduct(selectedRows) {
      if (!selectedRows || selectedRows.length === 0) {
        this.selectedProduct = null;
        this.selectedSpecs = [];
        this.form.goodsId = null;
        return;
      }
      const firstRow = selectedRows[0];
      this.selectedProduct = {
        id: firstRow.goodsId,
        name: firstRow.goodsName,
        mchName: firstRow.mchName,
        shopName: firstRow.shopName
      };
      this.form.goodsId = firstRow.goodsId;
      this.selectedSpecs = selectedRows.map(row => ({
        specsId: row.id,
        specsName: row.combNames,
        seckillPrice: row.price,
        price: row.price,
        stock: row.stock,
        seckillStock: 0,
        singleLimit: 0,
        totalLimit: 0,
        status: 1,
        goodsId: row.goodsId
      }));
    },
    decreaseSecKillStock(row) {
      if (row.seckillStock > 0) {
        row.seckillStock--;
      }
    },
    increaseSecKillStock(row) {
      if (row.seckillStock < row.stock) {
        row.seckillStock++;
      }
    },
    removeSpec(row) {
      const index = this.selectedSpecs.indexOf(row);
      if (index > -1) {
        this.selectedSpecs.splice(index, 1);
      }
    },
    handleClose() {
      this.$emit("update:visible", false);
    },
    handleCancel() {
      this.$emit("update:visible", false);
    },
    isPriceError(row) {
      if (!this.isSubmitted) return false;
      return (
        row.seckillPrice === null ||
        row.seckillPrice === undefined ||
        row.seckillPrice === "" ||
        Number(row.seckillPrice) <= 0
      );
    },
    isStockError(row) {
      if (!this.isSubmitted) return false;
      return (
        row.seckillStock === null ||
        row.seckillStock === undefined ||
        row.seckillStock === "" ||
        Number(row.seckillStock) <= 0
      );
    },
    handleConfirm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (!this.selectedProduct || !this.selectedSpecs.length) {
            this.$message({ type: "warning", message: "请选择商品" });
            return;
          }

          this.isSubmitted = true;

          const hasInvalidPrice = this.selectedSpecs.some(row => this.isPriceError(row));
          if (hasInvalidPrice) {
            this.$message({ type: "warning", message: "秒杀价必须大于0且不能为空" });
            return;
          }

          const hasInvalidStock = this.selectedSpecs.some(row => this.isStockError(row));
          if (hasInvalidStock) {
            this.$message({ type: "warning", message: "秒杀库存必须大于0且不能为空" });
            return;
          }

          const params = { ...this.form };
          params.specsJson = JSON.stringify(this.selectedSpecs);
          console.log(params);

          if (params.id === null) {
            delete params.id;
          }
          console.log("spec", this.selectedSpecs);
          this.$emit("confirm", params);
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.dialog-footer {
  text-align: right;
}

.has-error {
  ::v-deep .el-input__inner {
    border-color: #f56c6c !important;
  }
}

.error-tip {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  margin-top: 4px;
}
</style>
